(() => {
  if (customElements.get("product-share-native")) return;

  class ProductShareNative extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.button = this.querySelector(".product-share-native__button");
      this.label = this.querySelector("[data-share-label]");
      this.status = this.querySelector("[data-share-status]");
      this.defaultLabel = this.label?.textContent.trim() || "Compartilhe este produto";
      this.handleClick = this.share.bind(this);
      this.button?.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener("click", this.handleClick);
      window.clearTimeout(this.feedbackTimer);
      this.initialized = false;
    }

    async share() {
      const url = this.dataset.shareUrl || window.location.href;
      const shareData = {
        title: this.dataset.shareTitle || document.title,
        text: this.dataset.shareText || "",
        url
      };

      if (typeof navigator.share === "function") {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error?.name === "AbortError") return;
        }
      }

      await this.copyLink(url);
    }

    async copyLink(url) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          const temporaryInput = document.createElement("textarea");
          temporaryInput.value = url;
          temporaryInput.setAttribute("readonly", "");
          temporaryInput.style.position = "fixed";
          temporaryInput.style.opacity = "0";
          document.body.appendChild(temporaryInput);
          temporaryInput.select();

          const copied = document.execCommand("copy");
          temporaryInput.remove();

          if (!copied) throw new Error("Não foi possível copiar o link.");
        }

        this.showFeedback("Link copiado!", "Link copiado. Agora é só enviar para uma amiga.");
      } catch (error) {
        this.showFeedback(this.defaultLabel, "Não foi possível copiar. Tente novamente.");
      }
    }

    showFeedback(label, message) {
      window.clearTimeout(this.feedbackTimer);

      if (this.label) this.label.textContent = label;
      if (this.status) this.status.textContent = message;

      this.feedbackTimer = window.setTimeout(() => {
        if (this.label) this.label.textContent = this.defaultLabel;
        if (this.status) this.status.textContent = "";
      }, 4000);
    }
  }

  customElements.define("product-share-native", ProductShareNative);
})();
